import { FoodsIconButton } from "@foodpilot/foods";
import { Stack, Typography, Box, useTheme, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useActionsContext } from "src/context/Actions/useActionsContext";

type TabHeaderProps = {
    title: string;
};
export const TabHeader = (props: TabHeaderProps) => {
    const { title } = props;
    const theme = useTheme();
    const { t } = useTranslation();

    const { actionPlan, setOpenInitForm } = useActionsContext();

    const startingCampaign = actionPlan?.startSsqPost.campaign?.label;

    return (
        <Stack flexDirection={"row"} gap={theme.spacing(2)}>
            <Typography variant="h2">{title}</Typography>
            <Box sx={{ height: "40px", borderLeft: `1px solid ${theme.custom.grey[500]}` }} />
            <Stack flexDirection={"row"} gap={theme.spacing(0.5)} alignItems={"center"}>
                <Typography variant="body">{t("glossary.from")}</Typography>
                <Typography variant="body-bold">{startingCampaign}</Typography>
                <Typography variant="body">{t("glossary.to")}</Typography>
                <Typography variant="body-bold">{actionPlan?.endCampaign.label}</Typography>
            </Stack>
            <FoodsIconButton
                withBackground
                size={"s"}
                icon={"settings"}
                buttonProps={{
                    onClick: () => setOpenInitForm(true),
                }}
            />
        </Stack>
    );
};
